module.exports = __webpack_public_path__ + "fonts/ToyotaType-Semibold.de65ff6.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaType-Semibold.woff2
// module id = 06Wx
// module chunks = 13